import { useRef, useState } from 'react'
import { useIntl } from 'react-intl'
import { observer } from 'mobx-react'

import { useStore } from 'Stores/index'

import { AVAILABLE_LANGUAGES_ARRAY } from 'Constants/locale'

export const PublicRequestReturnLabelLanguageSwitcher = observer(() => {
  const { portalSettingsStore } = useStore()
  const { i18n, setI18n } = portalSettingsStore
  const [isOpen, setIsOpen] = useState(false)
  const intl = useIntl()
  const containerRef = useRef<HTMLDivElement>(null)

  const otherLanguages = AVAILABLE_LANGUAGES_ARRAY.filter(
    ({ language }) => language !== i18n.language,
  )

  const handleToggle = () => {
    setIsOpen(prev => !prev)
  }

  const handleBlur = (event: React.FocusEvent) => {
    if (!containerRef.current?.contains(event.relatedTarget)) {
      setIsOpen(false)
    }
  }

  return (
    <div
      ref={containerRef}
      className="PublicRequestReturnLabelLanguageSwitcher"
      onBlur={handleBlur}
    >
      <button
        aria-expanded={isOpen}
        aria-label={intl.formatMessage({ id: 'Language' })}
        className="PublicRequestReturnLabelLanguageSwitcher-toggle"
        onClick={handleToggle}
        type="button"
      >
        <img alt={i18n.name} height={20} src={i18n.flag} width={20} />
      </button>

      {isOpen && (
        <div className="PublicRequestReturnLabelLanguageSwitcher-menu">
          {otherLanguages.map(lang => (
            <button
              key={lang.language}
              className="PublicRequestReturnLabelLanguageSwitcher-option"
              onClick={() => {
                setI18n(lang)
                setIsOpen(false)
              }}
              type="button"
            >
              <img alt={lang.name} height={20} src={lang.flag} width={20} />
              <span>{lang.name}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  )
})
